import { Box, LabeledCheckbox } from '@asktia/tia-ui'
import { FC } from 'react'
import { QuestionFormGlue } from '../../types'
import { FollowUpQuestionsCard } from '../FollowUpQuestionsCard'
import { isItemEnabled } from '@asktia/tia-fhir-questionnaire'
import { ThemeUIStyleObject } from '@theme-ui/css'
import { getFieldName } from 'src/flows/questionnaires/hooks/useQuestionnaireResponse'
import {
    QuestionnaireItem,
    QuestionnaireResponseAnswer
} from '@asktia/tia-fhir-models'

export interface IBooleanInput {
    questionnaireItem: QuestionnaireItem
    answersMap: Map<string, QuestionnaireResponseAnswer[]>
    variant?: 'info'
    sx?: ThemeUIStyleObject
    index?: number
    placeholder?: string
    triggerSave: (triggerByFieldName: string) => void
}

export const BooleanInput: FC<IBooleanInput> = ({
    questionnaireItem,
    answersMap,
    index,
    triggerSave
}) => {
    const name = getFieldName(questionnaireItem, index)
    const label = questionnaireItem.text
    const defaultChecked = answersMap.get(name)?.at(0)?.valueBoolean

    return (
        <LabeledCheckbox
            name={name}
            defaultChecked={defaultChecked}
            onClick={() => triggerSave(name)}
            sx={{
                display: 'flex'
            }}
        >
            <span
                style={{
                    width: 'calc(100% - 56px)',
                    paddingTop: '6px',
                    lineHeight: '24px',
                    fontWeight: '500'
                }}
            >
                {label}
            </span>
        </LabeledCheckbox>
    )
}

export const GluedBooleanInputQuestion = ({
    linkId,
    questionnaire,
    answersMap,
    questionnaireResponse,
    sx,
    variant,
    followupCardSx,
    index,
    triggerSave
}: QuestionFormGlue & {
    linkId: string
    variant?: 'info'
    followupCardSx?: ThemeUIStyleObject
    sx?: ThemeUIStyleObject
    placeholder?: string
}) => {
    const questions = questionnaire.item
    const questionConfig = questions?.find(
        question => question.linkId === linkId
    )

    if (!questionConfig?.linkId) {
        return null
    }

    let isEnabled = true

    if (questionConfig && !!questionConfig.enableWhen) {
        isEnabled = questionnaireResponse
            ? isItemEnabled(questionConfig!, questionnaireResponse)
            : false
    }

    const shouldRender = questionConfig?.linkId && isEnabled

    if (!shouldRender) {
        return null
    }

    return (
        <Box sx={{ mt: 4 }}>
            <FollowUpQuestionsCard
                hidden={variant !== 'info'}
                sx={followupCardSx}
            >
                <BooleanInput
                    questionnaireItem={questionConfig}
                    answersMap={answersMap}
                    sx={sx}
                    index={index}
                    triggerSave={triggerSave}
                />
            </FollowUpQuestionsCard>
        </Box>
    )
}
